module.exports = __webpack_public_path__ + "img/Woman-In-Yellow_working.6991b0d5.png";